<template>
    <div>
        <h2>Export Settings</h2>

        <form>
            <ExportFormField
                    :label="'Path to export JSON file:'"
                    :pathText="jsonFilePath"
                    :error="errorPathFileJSON"
                    @setPath="setPathJSON"
            ></ExportFormField>

            <ExportFormField
                    :label="'Path to export PNG file:'"
                    :pathText="imageFilePath"
                    :error="errorPathFilePNG"
                    @setPath="setPathPNG"
            ></ExportFormField>
        </form>

        <br>

        <Button :loading="sendStatus" @click="save">Save the Export settings</Button>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapActions } from 'vuex';
    import ExportFormField from "./ExportFormField";
    import Button from "../../../../components/Button";

    export default {
        name: "ExportSettingsTab",

        components: {
            Button,
            ExportFormField,
        },

        data() {
            return {
                sendStatus: false,
            }
        },

        computed: {
            ...mapState('saveSettings', [
                'jsonFilePath',
                'imageFilePath',
                'errorPathFileJSON',
                'errorPathFilePNG',
            ]),

        },

        methods: {
            ...mapMutations('saveSettings', [
                'setJSONFilePath',
                'setImageFilePath',
            ]),

            ...mapActions('saveSettings', [
                'saveTheSettings',
                'clearErrors',
            ]),

            setPathJSON(path) {
                this.setJSONFilePath(path);
            },

            setPathPNG(path) {
                this.setImageFilePath(path);
            },

            save() {
                this.sendStatus = true;

                this.saveTheSettings()
                    .finally(() => {
                        this.sendStatus = false;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },

        },

        beforeUnmount() {
            this.clearErrors();
        },

    }
</script>

<style>

</style>